/**
 * Level 9: Crystal Cavern
 * 
 * Vertical level with crystalline aesthetics:
 * - Purple/pink crystal theme
 * - Vertical progression
 * - Portal for speedrun shortcuts
 * - Multiple trampolines
 * 
 * @module configs/levels/Level09_CrystalCavern
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level09_CrystalCavern = {
    id: 9,
    name: 'Crystal Cavern',
    subtitle: 'Gem of the Deep',
    description: 'Navigate crystalline formations with precise timing.',
    
    worldWidth: 4800,
    worldHeight: 1800,
    playerStart: { x: 100, y: 1600 },
    
    theme: {
        bgGradient: ['#1a0033', '#330066'],
        platformColor: 0x6633cc,
        accentColor: 0xff66ff,
        particleColor: 0xcc99ff,
        ambient: 'crystal'
    },
    
    platforms: [
        { x: 0, y: 1700, w: 400, h: 50 },
        { x: 500, y: 1550, w: 100, h: 30 },
        { x: 700, y: 1400, w: 100, h: 30 },
        { x: 900, y: 1250, w: 100, h: 30 },
        { x: 1100, y: 1100, w: 350, h: 25 },
        { x: 1550, y: 950, w: 150, h: 20 },
        { x: 1350, y: 800, w: 150, h: 20 },
        { x: 1550, y: 650, w: 150, h: 20 },
        { x: 1800, y: 500, w: 300, h: 30 },
        { x: 2200, y: 700, w: 150, h: 20 },
        { x: 2450, y: 900, w: 150, h: 20 },
        { x: 2700, y: 1100, w: 200, h: 30 },
        { x: 3000, y: 1300, w: 250, h: 40 },
        { x: 3350, y: 1150, w: 150, h: 25 },
        { x: 3600, y: 1000, w: 200, h: 30 },
        { x: 3900, y: 1200, w: 350, h: 50 },
        { x: 4350, y: 1400, w: 450, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 1000, y: 1350, w: 80, h: 20, moveY: 150, speed: 0.003 },
        { x: 2100, y: 600, w: 100, h: 20, moveX: 100, speed: 0.004 },
        { x: 3200, y: 1200, w: 100, h: 20, moveY: 120, speed: 0.0035 }
    ],
    
    spikes: [
        { x: 1200, y: 1100 },
        { x: 1250, y: 1100 },
        { x: 2750, y: 1100 },
        { x: 3050, y: 1300 },
        { x: 3100, y: 1300 },
        { x: 4000, y: 1200 },
        { x: 4450, y: 1400 }
    ],
    
    stars: [
        { x: 700, y: 1300 },
        { x: 1100, y: 1000 },
        { x: 1550, y: 550 },
        { x: 1950, y: 400 },
        { x: 2700, y: 1000 },
        { x: 3600, y: 900 },
        { x: 4500, y: 1300 }
    ],
    
    enemies: [
        { x: 1200, y: 1050 },
        { x: 2000, y: 450 },
        { x: 2750, y: 1050 },
        { x: 3650, y: 950 },
        { x: 4100, y: 1150 }
    ],
    
    door: { x: 4650, y: 1250, w: 50, h: 300 },
    button: { x: 4250, y: 1395 },
    box: { x: 3700, y: 950, floating: true }, // MAGNETIC BOX
    goal: { x: 4750, y: 1300 },
    
    portals: [
        { x1: 400, y1: 1650, x2: 1900, y2: 450, color: 0xff66ff }
    ],
    
    trampolines: [
        { x: 1400, y: 1100, w: 60 },
        { x: 2950, y: 1300, w: 70 }
    ],
    
    speedrunTargets: { gold: 60, silver: 80, bronze: 110 }
};

export default Level09_CrystalCavern;
